import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Why 1st Choice", to: "/#why" },
  { label: "Calculator", to: "/#calculator" },
  { label: "Fees", to: "/#fees" },
  { label: "Training", to: "/#training" },
  { label: "Software", to: "/#software" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  const handleClick = (to) => {
    setOpen(false);
    if (to.startsWith("/#")) {
      const id = to.slice(2);
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => {
          document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
        }, 50);
      } else {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(to);
    }
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/80 backdrop-blur-xl border-b border-black/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex items-center justify-between h-28">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-3 group">
          <img
            src="/logo-transparent.png"
            alt="1st Choice Realty & Associates"
            className="h-16 sm:h-20 w-auto"
          />
          <div className="font-display text-[#0a0a0a] tracking-widest text-sm uppercase hidden sm:block">
            Sold By <span className="text-[#121275]">1st</span> Choice
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.to}
              onClick={() => handleClick(l.to)}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm text-black/70 hover:text-[#0a0a0a] transition-colors font-mono uppercase tracking-widest"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/apply"
            data-testid="nav-apply-button"
            className="btn-primary !py-2.5 !px-5 text-xs tracking-widest uppercase"
          >
            Apply Now
          </Link>
        </div>

        <button
          className="lg:hidden text-[#0a0a0a]"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white/95 backdrop-blur-xl border-t border-black/10">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <button
                key={l.to}
                onClick={() => handleClick(l.to)}
                className="text-left text-black/80 font-mono uppercase tracking-widest text-sm py-2"
              >
                {l.label}
              </button>
            ))}
            <Link to="/apply" className="btn-primary !py-3 mt-2 text-xs tracking-widest uppercase">
              Apply Now
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
